import { useEffect, useState } from "react";
import { ListData, ListItem } from "src/components/lists/senec-list/SenecList";

export const useListData = (data: ListData) => {
    const [history, setHistory] = useState<ListData[]>([data]);
    const [clickPath, setItemClickPath] = useState<string[]>([]);
    const [selectedItemPath, setSelectedItemPath] = useState<string[]>([]);
    const [selectedItem, setSelectedItem] = useState<string | undefined>();

    useEffect(() => {
        setHistory([data]);
    }, [data]);

    const onSelect = (listItem: ListItem) => {
        if (listItem.child) {
            const children: ListData = listItem.child;
            setHistory((prev: ListData[]) => [...prev, children]);

            // update itemClickPath when clicking on any item pointing to next level in the tree
            setItemClickPath([...clickPath, listItem.id]);
        } else if (listItem.id === selectedItem) {
            // reset selectedItemPath when unselect selectedItem
            setSelectedItem(undefined);
            setSelectedItemPath([]);
        } else {
            // set selectedItemPath when an item in last child of tree gets selected to highlight path on each level
            setSelectedItem(listItem.id);
            setSelectedItemPath([...clickPath, listItem.id]);
        }
    };

    const goBack = () => {
        setItemClickPath((prev: string[]) => prev.slice(0, -1));
        if (history.length > 1) {
            setHistory((prev: ListData[]) => prev.slice(0, -1));
        }
    };

    return {
        selectedItem,
        selectedItemPath,
        listData: history[history.length - 1],
        onSelect,
        goBack,
        clickPath,
    };
};
